import React, { useCallback, useMemo, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useIntl } from "react-intl";
import MembershipBillingPanel from "components/common/MembershipBillingPanel";
import {
  organizationMembershipPayRoute,
  organizationMembershipRoute,
  organizationMembershipsRoute,
  organizationMembershipStatusRoute,
  organizationMembershipVoidInstallmentsRoute,
} from "network/api-routes";

const OrganizationMembershipPanel = ({
  open,
  onClose,
  organization,
  member,
  membership: membershipFromList,
  user,
  onUpdated,
}) => {
  const intl = useIntl();
  const [actions, setActions] = useState({
    selectedCount: 0,
    paying: false,
    payLabel: null,
    onPay: null,
    voiding: false,
    voidLabel: null,
    onVoid: null,
  });

  const handleActionsChange = useCallback((next) => {
    setActions(next);
  }, []);

  const personName = member?.name || membershipFromList?.person?.name || "";

  const organizationId = organization?.id;
  const routes = useMemo(
    () =>
      organizationId
        ? {
            list: organizationMembershipsRoute(organizationId),
            detail: (membershipId) => organizationMembershipRoute(organizationId, membershipId),
            pay: (membershipId) => organizationMembershipPayRoute(organizationId, membershipId),
            status: (membershipId) => organizationMembershipStatusRoute(organizationId, membershipId),
            void: (membershipId) => organizationMembershipVoidInstallmentsRoute(organizationId, membershipId),
          }
        : null,
    [organizationId],
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {intl.formatMessage({ id: "membership.panel.title" }, { name: personName })}
      </DialogTitle>
      <DialogContent dividers>
        {routes && (
          <MembershipBillingPanel
            active={open}
            user={user}
            membershipFromList={membershipFromList}
            createBody={member ? { organization_member_id: member.id } : null}
            routes={routes}
            onUpdated={onUpdated}
            onActionsChange={handleActionsChange}
          />
        )}
      </DialogContent>
      <DialogActions>
        {actions.selectedCount > 0 && actions.onVoid && (
          <Button
            color="warning"
            variant="outlined"
            onClick={() => actions.onVoid?.()}
            disabled={actions.paying || actions.voiding}
          >
            {actions.voiding
              ? intl.formatMessage({ id: "membership.panel.voidingButton" })
              : actions.voidLabel}
          </Button>
        )}
        {actions.selectedCount > 0 && (
          <Button variant="contained" onClick={() => actions.onPay?.()} disabled={actions.paying || actions.voiding}>
            {actions.paying ? intl.formatMessage({ id: "membership.panel.payingButton" }) : actions.payLabel}
          </Button>
        )}
        <Button onClick={onClose}>{intl.formatMessage({ id: "membership.panel.close" })}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrganizationMembershipPanel;
